import LocalTime from "local-time"

// Replace "on {date}" with just "{date}"
const defaultEnConfig = LocalTime.config.i18n["en"]
// @ts-expect-error local_time is not typed
defaultEnConfig["date"]["on"] = "{date}"
LocalTime.config.i18n["en"] = defaultEnConfig

LocalTime.start()
document.addEventListener("turbo:morph", () => {
  LocalTime.run()
})
